var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialFacebook28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.894 15.302.57-3.62h-3.511V9.326c0-.99.49-1.957 2.057-1.957h1.619V4.286a19.617 19.617 0 0 0-2.85-.243c-2.89 0-4.776 1.737-4.776 4.877v2.761H8.8v3.621h3.203v8.759h3.95v-8.759h2.94Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook28);
export default __webpack_public_path__ + "static/media/social-facebook_28.1fb0d577.svg";
export { ForwardRef as ReactComponent };